var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 44.851,
    y1: 38,
    x2: 20.149,
    y2: 38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M44.851,38H62c0,0-7-18-29-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M31.887,20.028C32.257,20.018,32.622,20,33,20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M31.887,20.028C10.737,20.626,3,38,3,38h17.149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M31.887,20.028C31.926,20.021,31.961,20.008,32,20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M20.149,38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M31.887,20.028C23.441,21.826,20.756,34.354,20.149,38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M44.851,38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M33,20c8.537,1.707,11.241,14.337,11.851,18"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 32,
    y1: 38,
    x2: 32,
    y2: 78
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23,
    y1: 78,
    x2: 20,
    y2: 85
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23,
    y1: 78,
    x2: 11,
    y2: 51
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 82,85 78,78 23,78  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M23,78"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 81.5,
    cy: 28.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 81.5,
    y1: 12,
    x2: 81.5,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 81.5,
    y1: 40.5,
    x2: 81.5,
    y2: 45.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 89.827,
    y1: 37.042,
    x2: 93.173,
    y2: 40.757
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 69.5,
    y1: 28.5,
    x2: 64.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 98,
    y1: 28.5,
    x2: 93,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 72.873,
    y1: 37.042,
    x2: 69.527,
    y2: 40.757
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 89.857,
    y1: 20.357,
    x2: 93.203,
    y2: 16.643
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 72.903,
    y1: 20.357,
    x2: 69.558,
    y2: 16.643
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeach);
export default __webpack_public_path__ + "static/media/beach.e6bb24994c98f79b8beb91ea95b71966.svg";
export { ForwardRef as ReactComponent };